import { createSlice } from '@reduxjs/toolkit';

export const modalNames = [
  'addNewCard',
  'deleteCard',
  'confirmationCVV',
  'promotion',
  'promotionDetail',
  'selfPickup',
  'selfPickupGoSend',
  'manageCreditCard',
  'NumberConfirmation',
  'kredivoInstallment',
  'changePhoneNumber',
  'sortBy',
  'filters',
  'aboutBrand',
  'loading',
  'addToCart',
  'productAdded',
  'orderRetry',
  'ordersFilter',
  'userQR',
  'childrenList',
  'previewImage',
  'trackOrder',
  'notifyMe',
  'notifyMeSuccess',
  'packageReceived',
  'packageReceivedSuccess',
  'calendar',
  'previewEgift',
  'confirmationEgift',
  'moreReviews',
  'filterSkinType',
  'reviewSortBy',
  'filterReviewRating',
  'filterAge',
  'userPhotos',
  'campaignVoucherDetail',
  'campaignVideoDetail',
  'campaignProductDetail',
  'consent',
  'brandCategories',
  'confirmPublishReview',
  'confirmEditReview',
  'discardReview',
  'addPhoto',
  'actionReview',
  'reportReview',
  'requestToDeleteReview',
  'discardAddPhoto',
  'filterReviews',
  'reviewType',
  'dateOfBirth',
  'completedProfile',
  'successShareFAQ',
  'login',
  'productOos',
  'verifyAccount',
  'cropPhoto',
  'errorPage',
  'filterDatePicker',
  'egiftMessageTemplates',
  'egiftCropPhoto',
  'addReviewRecentlyBought',
  'chooseCombination',
  'datepicker',
  'ModalDetailOrder',
  'listCountries',
  'deleteAddress',
  'removeProductBabyRegistry',
  'shareBabyRegistry',
  'selectDelivery',
  'selectPickupLocation',
  'locationPermission',
  'deleteInStoreProduct',
  'calendarRegistry',
  'dynamicBanner',
  'addToBagRegistryWarning',
  'addToBagPreOrderWarning',
  'addRegistry',
  'requestPermission',
  'reportComment',
  'requestToDeleteArticle',
  'installment',
  'modalHowToPay',
  'legalStatements',
  'legalStatementsRegister',
  'addNewAddress',
  'pinPoint',
  'findAddress',
  'modalPaymentMethod',
  'modalRefund',
  'refundDetail',
  'deliveryProofImages',
  'buyWithVoucher',
  'modalOrderFilterByDate',
  'createReview',
  'publishReviewSuccess',
  'shareReview',
];

const createModalState = () => ({
  isShow: false,
  data: null,
});

const initialState = modalNames.reduce((modal, name) => {
  modal[name] = createModalState();
  return modal;
}, {});

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    show: (state, action) => {
      const { modalName, data = null } = action.payload;
      if (!state[modalName]) {
        return;
      }
      state[modalName].isShow = true;
      state[modalName].data = data;
    },
    hide: (state, action) => {
      const { modalName, data = null } = action.payload;
      if (!state[modalName]) {
        return;
      }
      state[modalName].isShow = false;
      state[modalName].data = data;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('MODAL/SHOW', (state, action) => {
      const { modalName, data = null } = action;
      if (!state[modalName]) {
        return;
      }
      state[modalName].isShow = true;
      state[modalName].data = data;
    });

    builder.addCase('MODAL/HIDE', (state, action) => {
      const { modalName, data = null } = action;
      if (!state[modalName]) {
        return;
      }
      state[modalName].isShow = false;
      state[modalName].data = data;
    });
  },
});

export const { show, hide } = modalSlice.actions;
export default modalSlice.reducer;
